import { HTTP_TYPES } from '@/lib/enums'
import api from '@/api/api'

const response = {
  async getTopics(): Promise<any> {
    return await api(
      HTTP_TYPES.GET,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/topics/`
    )
  },
  async getTaxonomies(): Promise<any> {
    return await api(
      HTTP_TYPES.GET,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/taxonomies/`
    )
  },
  async getSyncTopics(): Promise<any> {
    return await api(
      HTTP_TYPES.GET,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/mantle/sync-topics`
    )
  },
  async getSyncTaxonomies(): Promise<any> {
    return await api(
      HTTP_TYPES.GET,
      `${import.meta.env.VITE_DEPOT_API_ADMIN}/mantle/sync-taxonomies`
    )
  }
}

export default response
